module.exports = __webpack_public_path__ + "static/media/anni_logo.7eb5999c.png";